module.exports = __webpack_public_path__ + "img/6.f4c732f5.png";